class BoardCard {
  #word = null;
  #type = null;
  #revealed = false;

  constructor(word, type) {
    this.#word = word;
    this.#type = type;
  }

  get type() {
    return this.#type;
  }

  get revealed() {
    return this.#revealed;
  }

  get word() {
    return this.#word;
  }

  reveal() {
    this.#revealed = true;

    return this.type;
  }

  toJson() {
    return {
      type: this.type,
      revealed: this.revealed,
      word: this.word,
    };
  }
}

export default BoardCard;
